export default {
  confirmOrder: 'Bestellung bestätigen',
  createSuccess: 'Bestellung erfolgreich erstellt',
  orderPrice: 'Gesamtbestellpreis',
  otherAction: 'Weitere Aktionen',
  orderStatus: 'Bestellstatus',
  afterSales: 'Kundendienst',
  allSelect: 'Alle auswählen',
  orderNo: 'Bestellnummer',
  createTime: 'Erstellungszeit',
  productRemark: 'Produktinformationen',
  productRemarkHolder:
    'Nachricht für den Einkaufsagenten. Bei keinen besonderen Anforderungen bitte leer lassen.',
  orderDetail: 'Bestelldetails',
  goPay: 'Bezahlen',
  cancelpay: 'Zahlung abbrechen',
  cancelPay: 'Zahlung abbrechen?',
  cancelOrder: 'Bestellung stornieren?',
  cancelorder: 'Bestellung stornieren',
  cancelOrderProduct: 'Produkt stornieren?',
  cancelorderProduct: 'Produkt stornieren',
  cancelPayResultHint:
    'Nach der Stornierung kann die Zahlung nicht wiederhergestellt werden. Bitte wählen Sie den Grund für die Stornierung der Zahlung.',
  cancelOrderResultHint:
    'Nach der Stornierung kann die Bestellung nicht wiederhergestellt werden. Bitte geben Sie den Grund für die Stornierung der Bestellung an.',
  delOrder: 'Bestellung löschen',
  delOrderHint:
    'Sind Sie sicher, dass Sie die Bestellung löschen möchten? Wenn das Produkt bereits erstattet wurde, wird der Artikel nicht zur Rückerstattung an den Verkäufer zurückgesendet.',
  cancelSuccess: 'Stornierung erfolgreich',
  delSuccess: 'Löschung erfolgreich',
  orderBin: 'Papierkorb',
  backOrder: 'Zurück zu meiner Bestellung',
  restoreOrder: 'Bestellung wiederherstellen',
  remark: 'Bemerkungen',
  all: 'Alle',
  productName: 'Produktname',
  submitTime: 'Einreichungszeit',
  orderConsult: 'Bestellanfrage',
  appendService: 'Zusätzlicher Service',
  iKnow: 'Ich verstehe',
  cancelReturnBag: 'Rückgabe und Umtausch abbrechen',
  isCancelApply: 'Möchten Sie die Anfrage wirklich stornieren?',
  cancelBackTax: 'Zahlungsausgleich stornieren',
  productAttr: 'Produkteigenschaften',
  backTaxType: 'Art des Zahlungsausgleichs',
  taxPrice: 'Preis des Zahlungsausgleichs',
  productBackTax: 'Produktzahlungsausgleich',
  freightBackTax: 'Frachtzahlungsausgleich',
  productTaxPrice: 'Preis des Produktzahlungsausgleichs',
  freightTaxPrice: 'Preis des Frachtzahlungsausgleichs',
  totalTaxPrice: 'Gesamtpreis des Zahlungsausgleichs',
  productStatus: 'Produktstatus',
  isNeedTax: 'Zahlungsausgleich erforderlich',
  yes: 'Ja',
  no: 'Nein',
  iThinkAbout: 'Ich überlege es mir',
  revokeCheckedProduct: 'Ausgewähltes Produkt widerrufen',
  taxTips1:
    'Bitte [Zahlungsausgleich leisten] oder [Stornieren] Sie so schnell wie möglich, um den Kauf anderer Produkte in der Bestellung nicht zu beeinträchtigen.',
  cancelTaxTips1:
    'Wenn Sie den Zahlungsausgleich nicht leisten möchten, können wir das Produkt, für das ein Zahlungsausgleich erforderlich ist, nicht kaufen.',
  cancelTaxTips2:
    'Die markierten Produkte werden nach dem Widerruf storniert und die Produktkosten Ihrem Konto gutgeschrieben.',
  cancelTaxTips3:
    'Die nicht markierten Produkte bleiben erhalten und wir werden den Kauf für Sie fortsetzen.',
  cancelReason: {
    0: 'Ich möchte es nicht kaufen',
    1: 'Falsche Angaben gemacht',
    2: 'Verkäufer nicht auf Lager',
    3: 'Zahlung nicht möglich',
    4: 'Andere Gründe',
    5: 'Markenrisiko',
  },
  hint: 'Hinweis',
  orderStatusEnum: {
    0: 'Zahlung ausstehend',
    1: 'Unbearbeitet',
    2: 'In Überprüfung',
    3: 'Bestellung übertragen',
    4: 'Bestellung storniert',
    5: 'Frachtzahlungsausgleich',
    6: 'Risikoprüfung',
    7: 'Bestellung widerrufen',
    8: 'Zahlung in Bearbeitung',
    9: 'Abgeschlossen',
  },
  returnGood: {
    name: 'Rückgabe/Umtausch',
    selectType: 'Typ auswählen',
    returnGood: 'Rückgabe',
    returnDayTips: 'Dauert normalerweise 7-15 Tage',
    changeGood: 'Umtausch',
    changeDayTips: 'Dauert normalerweise 7-20 Tage',
    returnReasonEnum: {
      0: 'Falsch gekauft/Gefällt nicht',
      1: 'Verkäufer hat falsches Produkt geschickt?',
      2: 'Produktqualitätsmangel',
      3: 'Nicht innerhalb der vereinbarten Zeit versandt',
      5: 'Andere Gründe',
    },
    returnReasonSelect: 'Rückgabegrund auswählen',
    returnExplain: 'Rückgabeanweisungen',
    residueReturnNumTips: 'Verbleibende kostenlose Rückgaberechte in diesem Monat',
    returnTips:
      'Endgültige Überprüfung der Rückgabe aufgrund des Verkäufers oder der Plattform. Acbuy erstattet Ihnen die entstandenen Versandkosten.',
    changeTips:
      'Bei Rücksendungen oder Umtauschen aufgrund von Verkäuferfehlern müssen Sie möglicherweise einen Teil der Umtauschversandkosten tragen.',
    returnTip4: 'Freundliche Erinnerung',
    returnTip5:
      'Der Rückgabe- und Umtauschservice bietet eine bestimmte Anzahl kostenloser Bearbeitungszeiten. (Jeder Nutzer kann einmal im Monat kostenlos eine Rückgabe oder einen Umtausch beantragen, während die durch die Rückgabe oder den Umtausch entstandenen Versandkosten zwischen dem Agenten und dem Verkäufer ausgehandelt und von acbuy erhoben werden.) Acbuy Rückgabe- und Umtauschgebühr: 5 Yuan/Bestellung',
    returnTip10:
      'Wenn die Rückgabe oder der Umtausch auf die Verantwortung des Einkaufsagenten, des Verkäufers oder der Plattform zurückzuführen ist, erstattet das System diese 5 Yuan Bearbeitungsgebühr Ihrem Acbuy-Guthabenkonto.',
  },
  holder: {
    selectCancelReason: 'Bitte wählen Sie den Grund für die Stornierung',
    inputOtherReason: 'Bitte geben Sie den Grund ein',
    inputSearchHint: 'Name/Bestellnummer/Produktnummer',
    inputCancelReason: 'Bitte geben Sie den Grund für die Stornierung der Bestellung ein',
  },
  selectProducts: 'Produkte auswählen',
  confirmStepOrder: 'Bestellung bestätigen',
  PayForProducts: 'Für Produkte bezahlen',
  sendingPackages: 'Pakete versenden',
  submitDelivery: 'Für Lieferung einreichen',
  readAgreeText: 'Ich habe gelesen und stimme zu',
  disclaimer: 'Haftungsausschluss',
  orderNote:
    'Hinweis: Nach Abschluss der Zahlung müssen Sie das Paket für den internationalen Versand einreichen, sobald die Bestellung im Lager eintrifft und gelagert wird.',
  goPay2: 'Zusatzzahlung',
  backTax: 'Zahlungsausgleich leisten',
  reminder: 'Erinnerung',
  disclaimer1: 'Beschreibung verbotener Artikel',
  disclaimer2: 'Nutzungsbedingungen',
  disclaimer3: 'Rückgabebestimmungen',
  customPhotosTips: 'Ein Foto liefert nur eine Detailanforderung für die Aufnahme eines Artikels',
  backCartEdit: 'Zurück zur Warenkorbänderung',
  customPhotosReminderLabel: 'Freundliche Erinnerung',
  customPhotosReminder:
    'Ein Foto liefert nur eine Detailanforderung für die Aufnahme eines Produkts',
  packageAgreeTip1:
    '1. Verzögerungen, Beschädigungen, Verluste, Steuern, Beschlagnahmungen und andere Unsicherheiten im Zusammenhang mit den Dienstleistungen des Logistikdienstleisters liegen außerhalb unserer Kontrolle, und wir übernehmen keine Haftung für daraus resultierende Schäden. Wir werden jedoch alle Anstrengungen unternehmen, Sie daran zu erinnern, vor einem Kauf zweimal nachzudenken, Sie bei der Lösung von Problemen mit dem Logistikdienstleister zu unterstützen und Sie gemäß den vom Logistikdienstleister bereitgestellten After-Sales-Richtlinien zu entschädigen.',
  packageAgreeTip2:
    '2. Wir empfehlen Ihnen, Ihr Paket korrekt zu deklarieren. Wenn Ihr Paket während der Zollabfertigung im Zielland stichprobenartig kontrolliert wird, müssen Sie möglicherweise einige Steuern zahlen. Wenn Sie eine Steuerbenachrichtigung erhalten, zahlen Sie die Steuern entsprechend, andernfalls können Konsequenzen wie hohe Rücksendegebühren und die Vernichtung des Pakets drohen.',
  applyRefund: 'Rückerstattung beantragen',
  refundReminder:
    'Hinweis: Nach Beantragung einer Rückerstattung überprüft der Käufer den Status des Produkts und kann den Antrag auf Rückerstattung vor der Überprüfung nicht stornieren.',
  inputApplyReason: 'Bitte geben Sie den Grund für den Antrag ein',
  orderConfirm: 'Bestellung bestätigen',
  replyMsg: 'Antwortnachricht',
  replyMsgTips:
    'Hinweisinformationen, die Sie senden, wir werden den Käufer benachrichtigen, damit er sie überprüft.',
  shoppingOrder: 'Einkaufsagenturbestellungen',
  transportOrder: 'Paketweiterleitungsbestellungen',
  choosePlatform: 'Plattform auswählen',
  selectTargetCountry: 'Zielland auswählen',
  selectCountryTips:
    'Bitte wählen/geben Sie Ihr Zielland an, damit Acbuy unterscheiden kann, ob der Artikel geliefert werden kann oder nicht.',
  pleaseSelectOrder: 'Bitte wählen Sie Bestellungen in derselben Währung zur Abrechnung aus',
  canNotStorageTip:
    'Das Produkt ist seit mehr als 5 Tagen eingelagert und kann nicht zurückgegeben oder umgetauscht werden.',
  purchaseService: 'Einkaufsdienstleistungen',
  refundProgress: 'Rückerstattung wird bearbeitet',
  returnChangeTip:
    'Hinweis: Wenn das Produkt geringfügige Qualitätsmängel aufweist (Klebereste, Fehler, Flecken), übernimmt der Verkäufer möglicherweise nicht die Rücksendekosten. In diesem Fall müssen Sie die Versandkosten selbst tragen!',
  goodNumTip:
    'Hinweis: Wenn die Bestellmenge desselben Produkts 10 Stück oder mehr beträgt, führen die Qualitätsprüfer zur Verbesserung der Einlagerungseffizienz nur bei 20 % Ihrer Produkte Qualitätsprüfungen durch. Die Farben, Stile und Größen aller Produkte werden jedoch weiterhin für Sie überprüft. Vielen Dank für Ihr Verständnis!',
  'i18n-0000001': 'Kundenspezifisches Video',
  'i18n-0000002': 'Leistungsbeschreibung',
  'i18n-0000003':
    'Ein 20–90 Sekunden langes Produktvideo wird aufgenommen (die Dauer kann je nach Produkt variieren), das den Benutzern einen maßgeschneiderten Videoinspektionsdienst bietet.',
  'i18n-0000004':
    'Hinweis: Die Aktivierung elektronischer oder digitaler Produkte kann den Kundendienst nach dem Kauf aufheben. Die Plattform übernimmt keine Verantwortung.',
  'i18n-0000005':
    'Derzeit gibt es zu wenige nationale Routen. Es wird empfohlen, vor dem Kauf des Produkts die Frachtberechnungsseite oder die Warenkorbseite aufzurufen, um die Fracht zu berechnen und übermäßige Logistikkosten zu vermeiden.',
  'i18n-0000006': 'Lieferrouten ins Zielland: {lineNum}',
  buyAgain: 'Noch einmal kaufen',
  remindShop: 'Versand erinnern',
}
